import { useEffect } from "react";

/**
 * Sets `document.title` while the calling component is mounted and restores
 * the previous title on unmount, so the browser tab reflects the current
 * ITShopHW page instead of the static index.html default.
 *
 * @param title - The title to show while mounted.
 */
export const useDocumentTitle = (title: string): void => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
